import getNodeOffset from '../plugins/getNodeOffset'

export function clickMouseDown(e, direction) {
  let deviation = direction == 'right' ? -5 : 5

  // 存在 e.target 为子节点 获取父节点后再作处理
  let eareBox = e.target.classList.contains('single') ? e.target : e.target.parentNode,
  lineDrop = eareBox.querySelector('.line-drop')

  // 获取坐标 (.line-drop 圆心位置) 以body左上为原点
  let pos1 = {direction: 'move', key: '-1', ...getNodeOffset(lineDrop)}, pos2 = {}
  pos1.left += lineDrop.offsetWidth / 2
  pos1.top += lineDrop.offsetHeight / 2

  document.body.onmousemove = ev => {
    pos2 = {left: ev.pageX - deviation, top: ev.pageY, key: '-1'}

    this.ligature(pos1, pos2, 'body')

    // 只留最后那根线
    while(document.querySelectorAll(`.${pos1.direction}-${pos1.key}-${pos2.key}`).length > 1) {
      let tempLine = document.querySelectorAll(`.${pos1.direction}-${pos1.key}-${pos2.key}`)
      document.body.removeChild(tempLine[0])
    }
  }

  document.body.onmouseup = (ev) => {
    document.body.onmousemove = null
    document.body.onmouseup = null

    publicMethod(ev)
  }

  document.body.onmouseleave = ev => {
    document.body.onmousemove = null
    document.body.onmouseleave = null

    publicMethod(ev)
  }

  function publicMethod(ev) {
    // 消除临时线段
    let tempLine = document.querySelector(`.${pos1.direction}-${pos1.key}-${pos2.key}`)
    
    if(!tempLine) return;
    document.body.removeChild(tempLine)
    
    // 获取松开鼠标后停留的节点
    let target = ev.toElement, nodes = ['line-drop', 'single', 'value', 'image'],
    res = nodes.some(its => {
      // 必须在ligature-list节点内 且 必须是nodes列表中的节点
      if(target.offsetParent && target.offsetParent.classList.contains('ligature-list')
          && target.classList.contains(its)) 
      return true
    })

    let box = document.querySelector('.test-self')
    box.innerText = ''
    // box.insertAdjacentHTML('afterend', 'target.offsetParent: -> ' + target.offsetParent.classList + '<br/>')
    // box.insertAdjacentHTML('afterend', 'target Text: -> ' + target.innerText + '<br/>')
    // box.insertAdjacentHTML('afterend', 'target: -> ' + target.classList + '<br/>')
    // box.insertAdjacentHTML('afterend', 'eareBox: -> ' + eareBox.classList + '<br/>')
    // box.insertAdjacentHTML('afterend', 'eareBox Text: -> ' + eareBox.innerText + '<br/>')
    // box.insertAdjacentHTML('afterend', '是否包含 -> ' + eareBox.contains(target) + '<br/>')
    // for(let i in ev) {
    //   box.insertAdjacentHTML('afterend', i + '-> ' + ev[i] + '<br/>')
    // }
    

    if(res && !eareBox.contains(target)) {
      lineDrop.click()
      target.click()
    } 
  }
}